import React from "react";
import styled from "styled-components";
import {defaultThemeColors} from "ui/theme";
import MediaImg from "static/pictures/Media.png";
import {StarIcon} from "ui/icons/inputIcons/StarIcon";
import {GroupIcon} from "ui/icons/inputIcons/GroupIcon";
import {GlobalIcon} from "ui/icons/inputIcons/GlobalIcon";
import {capitalizeFirstLetter, getAvatarUrl} from "utils";
import {onlineTypeMap} from "conts";

export const ClassInfoCard = ({classInfo}) => {
    const profileImageSrc = classInfo?.profile_pic
        ? getAvatarUrl(classInfo.profile_pic)
        : MediaImg;

    return (
        <CardContainer>
            <img src={profileImageSrc} alt={profileImageSrc}/>
            <ClassTitle>{classInfo?.class}</ClassTitle>
            <InfoRow>
                {classInfo?.first_name && <Name>{classInfo.first_name}</Name>}
                <StarIcon color="#FF827A"/> <Rating>{classInfo?.rating || 0}</Rating>
                ({classInfo?.review || 0} reviews)
            </InfoRow>
            <InfoRow>
                <GroupIcon/> <p>{capitalizeFirstLetter(classInfo?.class_type)}</p>
            </InfoRow>
            <InfoRow>
                <GlobalIcon/> {onlineTypeMap?.[classInfo.online_type] || ''}
            </InfoRow>
        </CardContainer>
    );
};

const CardContainer = styled.div`
    & > img {
        object-fit: contain;
        max-width: 300px;
        width: 100%;
        aspect-ratio: 1 / 1;
        border-radius: 5px;
        border-width: 2px;
        border-style: solid;
        border-color: ${defaultThemeColors.lightBlue};
    }
`;

const ClassTitle = styled.h3`
    margin-top: 10px;
    text-align: left;
`;

const InfoRow = styled.div`
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-size: 1rem;

    svg {
        margin-right: 8px;
    }
`;

const Name = styled.div`
    font-size: 1.17em;
    font-weight: 600;
    color: ${defaultThemeColors.txt};
    margin-right: 8px;
`

const Rating = styled.div`
    color: ${defaultThemeColors.pink};
    margin-right: 8px;
`